module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('el-row', {
    staticStyle: {
      "padding": "10px 0px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "refCode",
      "label": _vm.$t('product.refCode'),
      "rules": [{
        required: true,
        message: 'Please input reference code',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.refCode),
      callback: function($$v) {
        _vm.form.refCode = $$v
      },
      expression: "form.refCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category",
      "label": _vm.$t('product.category'),
      "rules": [{
        required: true,
        message: 'Please input category',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.category),
      callback: function($$v) {
        _vm.form.category = $$v
      },
      expression: "form.category"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "title",
      "label": _vm.$t('product.name'),
      "rules": [{
        required: true,
        message: 'Please input name',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.form.title = $$v
      },
      expression: "form.title"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "size",
      "label": _vm.$t('product.size'),
      "rules": [{
        required: true,
        message: 'Please input size',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.size),
      callback: function($$v) {
        _vm.form.size = $$v
      },
      expression: "form.size"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "productType",
      "label": _vm.$t('product.type'),
      "rules": [{
        required: true,
        message: 'Please input productType',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.productType),
      callback: function($$v) {
        _vm.form.productType = $$v
      },
      expression: "form.productType"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "discountable",
      "label": _vm.$t('product.discountable')
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.form.discountable),
      callback: function($$v) {
        _vm.form.discountable = $$v
      },
      expression: "form.discountable"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('product.extraDescription')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.form.description = $$v
      },
      expression: "form.description"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "price",
      "label": _vm.$t('product.price'),
      "rules": [{
        required: true,
        message: 'Please input price',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.price),
      callback: function($$v) {
        _vm.form.price = $$v
      },
      expression: "form.price"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit(_vm.form, true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.continueCreate')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit(_vm.form)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.save')))]), _vm._v(" "), _c('el-button', [_vm._v(_vm._s(_vm.$t('base.cancel')))])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57ab9e41"}!./src/pages/product/new/index.html
// module id = 812
// module chunks = 1